import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './pages/components';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0f172a',
    },
    secondary: {
      main: '#f59e0b',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Poppins, Segoe UI, sans-serif',
    h5: {
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 12,
  },
});


function App() {
  return (
    <ThemeProvider theme={theme} >
      <BrowserRouter >
        <Routes >
          <Route path="/" element={<Header />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
